import PropTypes from 'prop-types';
import { addMonths, isWithinInterval } from 'date-fns';
import { useTranslation } from 'next-i18next';

// Utils
import { formatDate } from 'utils';
// Components
import Tag from '../../atoms/Tag/Tag';

function OpeningDateTag({ openingDate }) {
  let tagValue = null;
  const currentDate = new Date();
  const sixMonthsFromNow = addMonths(currentDate, 6);
  const openingDateObj = new Date(openingDate);
  // Hooks
  const { t } = useTranslation();

  if (!openingDate || (currentDate > openingDateObj)) return null;

  if (isWithinInterval(openingDateObj, { start: currentDate, end: sixMonthsFromNow })) {
    tagValue = `${t('presentationBlock.opening', { date: formatDate(openingDateObj, 'MMMM yyyy') })}`;
  } else {
    tagValue = t('presentationBlock.openingSoon');
  }

  return <Tag color="white" content={tagValue} weight="light" />;
}

OpeningDateTag.propTypes = {
  openingDate: PropTypes.string,
};

OpeningDateTag.defaultProps = {
  openingDate: '',
};

export default OpeningDateTag;
